import { z } from 'zod';
import { paginationQuerySchema } from './common.js';
/**
 * Impression par lot (module `apps/api/src/modules/impression/`) — voir
 * `docs/hardware-integration.md` §4 pour le contexte complet (pourquoi un lot
 * plutôt qu'un `window.print()` par carte, ce qui est simulé aujourd'hui vs.
 * réel). Ces schémas ne valident que la forme des requêtes ; la légalité des
 * transitions de statut de carte reste dans `CARTE_TRANSITIONS`
 * (`../constants/statuses.ts`), appliquée via `applyCarteTransition`.
 */
export const creerLotImpressionSchema = z.object({
    carteUuids: z.array(z.string().uuid()).min(1, 'Sélectionnez au moins une carte'),
    reference: z.string().max(160).optional(),
});
export const listLotsImpressionQuerySchema = paginationQuerySchema;
/**
 * Source de sélection pour l'écran de création d'un lot d'impression :
 * cartes déjà `personnalisee` (donc éligibles), pas encore mises en lot.
 * Recherche sur le numéro de carte ou le nom du travailleur, même principe
 * que `listTravailleursQuerySchema` (`./referentiel.ts`).
 */
export const listCartesPersonnaliseesQuerySchema = paginationQuerySchema.extend({
    search: z.string().max(160).optional(),
});
/**
 * Résultat d'une tentative d'impression, rapporté par l'agent d'impression
 * local (voir docs/hardware-integration.md §4). C'est le **matériel** qui
 * décide du statut de la carte, jamais un opérateur : un agent ne peut donc
 * rapporter que ce que l'imprimante lui a répondu.
 */
export const rapporterResultatImpressionSchema = z
    .object({
    resultat: z.enum(['succes', 'echec']),
    /** Motif lisible, repris du spouleur ou du SDK (ex. « Bourrage carte »). */
    motifEchec: z.string().max(300).optional(),
})
    .refine((v) => v.resultat === 'succes' || Boolean(v.motifEchec), {
    message: 'Un échec doit préciser son motif',
    path: ['motifEchec'],
});
//# sourceMappingURL=impression.js.map